const findIndex = (index) => {
    const indexOptions = [
        'farcaster-items',
        'farcaster-users',
        'zora-coins',
        'polymarket-items',
        'token-items',
        'wallet-users',
        'polymarket-wallets',
        'kalshi-items',
        'notification-hyperliquid-wallets',
        'notification-hyperliquid-wallet-positions',
        // Order matters for startsWith: list -wallet-positions before -wallets.
        'hyperliquid-wallet-positions',
        'hyperliquid-wallets',
        // Friendly aliases for alpha-trade-events-* and alpha-notifications-*.
        // Keep the verbose underlying names too in case anything still queries them.
        'hyperliquid-items',
        'hyperliquid-notifications',
        'polymarket-notifications',
        'dex-notifications',
        'hyperliquid-trades',
        'polymarket-trades',
        'base-trades',
        'ethereum-trades',
        'solana-trades',
        'alpha-notifications-dex',
        'alpha-notifications-polymarket',
        'alpha-notifications-hyperliquid',
        'alpha-trade-events-hyperliquid',
    ];
    for (const option of indexOptions) {
        if (index.startsWith(option)) {
        return option;
        }
    }
    return null;
};

export { findIndex };
